import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';  
import { ToolBarComponent } from './Components/Common/tool-bar/tool-bar.component';
import { SideMenuComponent } from './Components/Common/side-menu/side-menu.component';

import { NgxSpinnerModule } from "ngx-spinner";
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CustomInterceptor } from './interceptor/custom-interceptor';
import { ErrorPageComponent } from './Components/Common/error-page/error-page.component';
import { StocktakeFormComponent } from './Components/Content/stocktake-form/stocktake-form.component';
import { MatNativeDateModule } from '@angular/material/core';
import { SignaturePadModule  } from 'angular2-signaturepad';
import { CredentialDialogComponent } from './Components/credential-dialog/credential-dialog.component';

@NgModule({
    declarations: [
        AppComponent,
        ToolBarComponent,
        SideMenuComponent,
        ErrorPageComponent,
        StocktakeFormComponent,
        CredentialDialogComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        CommonModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatToolbarModule,
        MatSidenavModule,
        MatTooltipModule,
        MatGridListModule,
        MatCardModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        AngularEditorModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        NgxSpinnerModule,
        MatRadioModule,
        MatCheckboxModule,
        NgxMatSelectSearchModule,
        SignaturePadModule 
    ],
    exports: [
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatGridListModule,
        MatToolbarModule,
        MatSidenavModule,
        MatTooltipModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        NgxSpinnerModule,
        MatRadioModule,
        MatCheckboxModule,
        NgxMatSelectSearchModule,
        SignaturePadModule 
    ],
    providers: [
        MatDatepickerModule,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomInterceptor,
            multi: true
        }
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
